<template>
</template>

<script>
import { routerController, isDev, urls } from '@js'

export default {
  props: {},
  data: function() {
    return {
      isCheck: false,
      test_d: {
        exact_status: 'failed',
        expire: 100,
        is_login: true,
        status: 'onboarding'
      }
    }
  },
  methods: {
    timeout() {
      //时效性
      let now = new Date().getTime()
      setTimeout(() => {
        // console.log(`========================== now: ${now} === pass_date: ${this.pass_date} ===================`)
        if (now >= this.pass_date) {
          //alert(now>=this.pass_date+','+'时效性结束')
          // window.location.href = urls.goLogout
        }
        this.timeout()
        //console.log(now-this.pass_date)
      }, 5000)
    }
  },
  computed: {
    ticket() {
      try {
        let params = window.location.href.split('?')[1]
        let arrs = params.split('&')
        for (let opt of arrs) {
          if (opt.split('=')[0] == 'ticket') {
            return opt.split('=')[1]
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    pass_date() {
      return this.$store.state.pass_date // 本地测试数据
    }
  },
  beforeRouteEnter(to, from, next) {
    /*注册页面的自动登陆，需要将ticket传入，手动登陆不需要;sid是ats后台登陆之后，ats前台也能登陆,因此不会走自动登陆（即ticket和sid不会同时存在）*/
    next(vm => {
      let sid = vm.$route.query.sid
      let url = ''

      console.log(vm.$route.query, vm.$route.query.sid)
      if (vm.ticket) {
        //自动登陆
        url = '/index/login' + '?ticket=' + vm.ticket
      } else if (sid) {
        //后台登陆后，前台免登陆
        url = '/index/login' + '?sid=' + sid
      } else {
        //登陆页手动登陆
        url = '/index/login'
      }

      vm.axios.get(url).then(function(d) {
        vm.$store.commit('update_login_status', d.data.res)
        /******************登陆时效性************************/
        try {
          vm.$store.commit('setCookie', {
            key: 'logined',
            value: d.data.res.expire
          }) //种下or更新过期时间
          vm.$store.commit('getCookie', { name: 'logined' }) //从cookie获取过期时间
          // if (!isDev()) {
            vm.timeout() //开启时效性
          // }
        } catch (e) {
          console.log(e)
        }

        /*alert('login_status:'+d.data.res.is_login)
        alert('status:'+d.data.res.status)
        alert('exact_status:'+d.data.res.exact_status)*/

        // return false;   //本地调试需放开此行，打包之前注释掉

        /*****************记录用户登陆状态*****************/
        if (d.data.code == '75000' && d.data.res.is_login) {
          //alert('login_status success')
          let state = d.data.res.status //大状态

          let exact_state = d.data.res.exact_status //精准状态

          routerController.call(vm, { state, exact_state })
        } else if (d.data.code == '75092') {
          //兼容老系统，已上线老师登陆到老系统
          window.location.href = d.data.res.url
        } else {
          //alert('login_status error')
          //服务器错误，跳转至登陆页面
          vm.$message({
            showClose: true,
            message: 'Oops, sign in failed. Please try again.',
            duration: 0,
            type: 'error',
            onClose: function() {
              window.location.href = urls.ssoLogin
            }
          })
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// login_status.vue?c6f1f092